// extracted by mini-css-extract-plugin
export default {"auksionSetting":"auksionSetting_auksionSetting__2vwiL","auksionSetting_container":"auksionSetting_auksionSetting_container__X2L51"};